import { render, staticRenderFns } from "./DistributionStatus.vue?vue&type=template&id=74ffbeea&scoped=true&"
import script from "./DistributionStatus.vue?vue&type=script&lang=js&"
export * from "./DistributionStatus.vue?vue&type=script&lang=js&"
import style0 from "./DistributionStatus.vue?vue&type=style&index=0&id=74ffbeea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ffbeea",
  null
  
)

export default component.exports